import { createRouter, createWebHistory } from 'vue-router'
import store from '../store'
import userAuthenticate from '../functions/userAuthenticate'
import { getBrandConfig } from '../brand'

const routes = [
  {
    path: '/',
    redirect: () => {
      const brandConfig = store.state.brandConfig || getBrandConfig()
      return brandConfig?.baseRoute || '/home'
    }
  },
  {
    path: '/home',
    name: 'Home',
    component: () => import(/* webpackChunkName: "home" */ '../views/Home.vue')
  },
  {
    path: '/news',
    name: 'News',
    component: () => import(/* webpackChunkName: "news" */ '../views/News.vue')
  },
  {
    path: '/news/article/:articleId',
    name: 'NewsDetail',
    component: () => import(/* webpackChunkName: "news-detail" */ '../views/pages/NewsDetail.vue'),
    props: true
  },
  {
    path: '/fixtures',
    name: 'Fixtures',
    component: () => import(/* webpackChunkName: "fixtures" */ '../views/Fixtures.vue')
  },
  {
    path: '/profile',
    name: 'Profile',
    component: () => import(/* webpackChunkName: "profile" */ '../views/Profile.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/live-tv',
    name: 'LiveTV',
    component: () => import(/* webpackChunkName: "live-tv" */ '../views/pages/LiveTV.vue')
  },
  {
    path: '/trivia',
    name: 'DailyQuiz',
    component: () => import(/* webpackChunkName: "trivia" */ '../views/pages/DailyQuiz.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/zone/:id',
    name: 'SportsZone',
    component: () => import(/* webpackChunkName: "sports-zone" */ '../views/pages/SportsZone.vue'),
    props: true,
    meta: { requiresSubscription: true }
  },
  {
    path: '/onboarding',
    name: 'Onboarding',
    component: () => import(/* webpackChunkName: "onboarding" */ '../views/pages/Onboarding.vue')
  },
  {
    path: '/otp-verification',
    name: 'OTPVerification',
    component: () => import(/* webpackChunkName: "otp" */ '../views/pages/OTPVerification.vue')
  },
  {
    path: '/subscribe',
    name: 'Subscribe',
    component: () => import(/* webpackChunkName: "subscribe" */ '../views/Subscribe.vue')
  },
  {
    path: '/subscription-success',
    name: 'SubscriptionSuccess',
    component: () => import(/* webpackChunkName: "subscription-success" */ '../views/pages/SubscriptionSuccess.vue')
  },
  {
    path: '/subscription-error',
    name: 'SubscriptionError',
    component: () => import(/* webpackChunkName: "subscription-error" */ '../views/pages/SubscriptionError.vue')
  },
  {
    path: '/unsubscribe',
    name: 'Unsubscribe',
    component: () => import(/* webpackChunkName: "unsubscribe" */ '../views/Unsubscribe.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/select-teams',
    name: 'SelectTeams',
    component: () => import(/* webpackChunkName: "select-teams" */ '../views/pages/SelectTeams.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: '/home'
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { top: 0 }
    }
  }
})

// Navigation guard for authentication
router.beforeEach(async (to, from, next) => {
  await userAuthenticate(to, from, next, store)
})

let _postTealiumPageView = null
router.afterEach((to, from) => {
  const brandConfig = store.state.brandConfig
  if (!brandConfig?.brand?.includes('vc')) return
  // Dispatch is internally deferred until utag.js is ready (readiness queue
  // in tealium.js), so we no longer need an arbitrary settle delay here.
  if (_postTealiumPageView) {
    _postTealiumPageView(to, from, brandConfig)
    return
  }
  import('@/services/tealium')
    .then((mod) => {
      _postTealiumPageView = mod.postTealiumPageView
      _postTealiumPageView(to, from, brandConfig)
    })
    .catch(() => {})
})

export default router
